import PropTypes from "prop-types";

import { emotionColorMap, emotionImageMap } from "../../helpers/charts";

const EmotionPercentile = ({ emotion, percentile }) => (
	<div className="emotion-percentile mb-2">
		<div className="d-flex justify-content-between w-100 mb-1">
			<strong>{emotion}</strong>
			<span>{percentile?.toFixed(2)}% Percentile</span>
		</div>
		<div className="emotion-percentile-bar w-100 bg-eqqo-pale-gray rounded-1 position-relative">
			<div className={`emotion-percentile-progress rounded-1 py-1 h-100 bg-${emotionColorMap[emotion]}`} style={{ width: `${percentile}%` }} />
			<img
				alt={emotion}
				className="emotion-percentile-icon position-absolute"
				height="44"
				src={emotionImageMap[emotion]}
				style={{ left: `${percentile}%`, top: "50%", transform: "translate(-50%, -50%)" }}
				width="44"
			/>
		</div>
	</div>
);

EmotionPercentile.propTypes = {
	emotion: PropTypes.string.isRequired,
	percentile: PropTypes.number.isRequired
};

export default EmotionPercentile;
